import { LmIconFilledCommunicationMessageCircle, LmIconOutlineCommunicationMessageCircle } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconProfessionProforientationRecommendationsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? (
    <LmIconOutlineCommunicationMessageCircle {...rest} />
  ) : (
    <LmIconFilledCommunicationMessageCircle {...rest} />
  );

export default IconProfessionProforientationRecommendationsCommon;
